import { useState, useEffect } from 'react';
import { getAttendeeTimezone } from '@/utils/dateTime';

/**
 * Hook to get the attendee's timezone from the browser.
 *
 * Uses useEffect to avoid hydration mismatches since
 * Intl.DateTimeFormat is a browser API that returns different
 * values on server vs client.
 *
 * @param enabled - Whether to resolve the timezone (typically true for online events)
 * @returns The attendee's IANA timezone string, or undefined if not yet resolved or disabled
 */
export const useAttendeeTimezone = (enabled: boolean): string | undefined => {
  const [timezone, setTimezone] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    setTimezone(getAttendeeTimezone());
  }, [enabled]);

  return timezone;
};
